export enum RenderQueueComponent {
  OfferDetail = 'OfferDetail',
  SeasonsEnd = 'SeasonsEnd',
  EventsTeaser = 'EventsTeaser',
  BoardGamesEventWindow = 'BoardGamesEventWindow',
  Minigame = 'Minigame',
  PiggyBank = 'PiggyBank',
}
